import { render, staticRenderFns } from "./NavAside.vue?vue&type=template&id=7b8fbac1&"
import script from "./NavAside.vue?vue&type=script&lang=ts&"
export * from "./NavAside.vue?vue&type=script&lang=ts&"
import style0 from "./NavAside.vue?vue&type=style&index=0&id=7b8fbac1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports